import { render, staticRenderFns } from "./MarketingSmsCreateHeader.vue?vue&type=template&id=34206c17&scoped=true"
import script from "./MarketingSmsCreateHeader.vue?vue&type=script&lang=js"
export * from "./MarketingSmsCreateHeader.vue?vue&type=script&lang=js"
import style0 from "./MarketingSmsCreateHeader.vue?vue&type=style&index=0&id=34206c17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34206c17",
  null
  
)

export default component.exports